import React from "react";
import { Route, Redirect } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import { PrivilegesGuard } from "../../shared/PrivilegesGuard";
import { history } from "../../history";
import { authService } from "../../services/AuthService";
import { useRestrictions } from "../hooks/useRestrictions";
import Loader from "../../Components/Common/Loader";

export const PrivateRoute = ({
  component: Component,
  restrictCondition,
  requiredPrivileges,
  privilegeLogical = "and",
  ...rest
}) => {
  const { isLoading, ...restrictions } = useRestrictions();

  const isRestricted = restrictCondition
    ? !restrictCondition(restrictions)
    : false;

  const notRestricted = authService.isLoggedIn() && !isRestricted;

  if (isLoading) {
    return <Loader showLoader isFullWidth />;
  }

  const render = (props) => {
    if (requiredPrivileges?.length > 0) {
      return (
        <PrivilegesGuard
          logical={privilegeLogical}
          requiredPrivileges={requiredPrivileges}
          renderFallback={() => {
            history.goBack();
            return null;
          }}
        >
          <Component {...props} />
        </PrivilegesGuard>
      );
    }

    return <Component {...props} />;
  };

  return (
    <Route
      {...rest}
      render={() =>
        notRestricted ? (
          <Route {...rest} render={render} />
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.login(),
            }}
          />
        )
      }
    />
  );
};
